import { useQuery } from "@apollo/client";
import { ODOO_COMPANY_IDS } from "AppSettings";
import Errors from "components/base/Errors";
import Spinner from "components/base/Spinner";
import { FETCH_ODOO_OBJECTS } from "graphql/query";
import AccountForm from "./AccountForm";

const CreateAccountView = ({ customer, ...props }) => {
  const filters = [["id", "=", customer.odooPartnerId]];

  const { loading, error, data } = useQuery(FETCH_ODOO_OBJECTS, {
    skip: !customer.odooPartnerId,
    variables: {
      model: "res.partner",
      method: "search_read",
      filters: JSON.stringify(filters),
      fields: ["name", "email"],
      companyId: ODOO_COMPANY_IDS[customer.system],
    },
  });

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const res = data ? JSON.parse(data.odooQuery)[0] : {};
  console.log("res", res);

  return <AccountForm initialEmail={res.email} {...props} />;
};

export default CreateAccountView;
